import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConfigSistemaService } from 'src/app/core/services/behavior/config-sistema.service';
import { AuthenticationService } from 'src/app/core/services/http/authentication.service';
import { EntregaService } from 'src/app/core/services/http/entrega.service';
import { EntregaPorBairroRequest, EntregaPorBairroViewModel } from 'src/app/shared/models/bairro.model';
import { Paginador } from 'src/app/shared/models/paginador.model';

@Component({
    selector: 'app-taxa-entrega',
    templateUrl: './taxa-entrega.component.html',
    styleUrls: ['./taxa-entrega.component.scss'],
})
export class TaxaEntregaComponent implements AfterViewInit, OnDestroy {
    @ViewChild('cabecalho') cabecalho: ElementRef;
    @ViewChild('inpValorEntrega') inpValorEntrega: ElementRef;
    @ViewChild('termoPesquisaBairro') inpPesquisaBairro: ElementRef;

    public carregando: boolean = false;

    public filtroEntregaEscopo: 'geral' | 'bairro' = 'geral';
    public termoPesquisa: string = '';

    public bairros: EntregaPorBairroViewModel[] = [];
    public bairrosFiltrados: EntregaPorBairroViewModel[] = [];
    public bairroSel = new EntregaPorBairroViewModel();

    public entregaGeral = new EntregaPorBairroRequest();
    public enviandoRequest: boolean = false;

    public paginador: Paginador = new Paginador(0, 0, 0);
    public itensPorPagina: EntregaPorBairroViewModel[] = [];
    public subs: Subscription[] = [];

    constructor(
        private router: Router,
        private entregaService: EntregaService,
        private authService: AuthenticationService,
        private configSistemaService: ConfigSistemaService,
    ) { }

    @HostListener('document:keyup', ['$event'])
    keyup(event: KeyboardEvent) {
        switch (event.key) {
            case 'ArrowLeft':
                this.alterarPagina(this.paginador.paginaAtual - 1);
                break
            case 'ArrowRight':
                this.alterarPagina(this.paginador.paginaAtual + 1);
        }
    }

    public ngAfterViewInit() {
        const sub = this.authService.isAuthenticated.subscribe((res) => {
            if (res) {
                setTimeout(() => {
                    this.carregarBairros();
                    this.carregarPaginador();
                    this.carregarEntregaGerais();
                });
            }
        });

        this.subs.push(sub);
    }

    ngOnDestroy() {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    public carregarBairros() {
        this.entregaService.getIntegracaoEntrega().subscribe({
            next: (res) => {
                if (res.success) {
                    const bairros = res.data as any;
                    bairros.forEach(bairro => {
                        const bairroViewModel = new EntregaPorBairroViewModel();

                        bairroViewModel.ativo = bairro.ativo;
                        bairroViewModel.bairro = bairro.bairro;
                        bairroViewModel.id = bairro.id;
                        bairroViewModel.tempoEntrega = bairro.tempoEntrega;
                        bairroViewModel.valorEntrega = bairro.valorEntrega;

                        this.bairros.push(bairroViewModel);
                    });

                    this.bairrosFiltrados = [...this.bairros];
                    this.carregarPaginador();
                }
            }
        })
    }

    public alterarEscopoEntrega() {
        switch (this.filtroEntregaEscopo) {
            case 'geral':
                this.inpValorEntrega.nativeElement.focus();

                break;
            case 'bairro':
                this.inpPesquisaBairro.nativeElement.focus();
        }
    }

    public home() {
        this.router.navigate(['home']);
    }

    public carregarPaginador() {
        const tamanhoDisplay = window.innerHeight - 400;
        this.paginador = new Paginador(tamanhoDisplay, 48, 0);

        this.carregarPaginas();
    }

    public carregarEntregaGerais() {
        this.entregaService.getEntregaGlobal().subscribe({
            next: (res) => {
                if (res.success) {
                    this.entregaGeral = res.data;
                    this.carregando = true;
                }
            }
        });
    }

    public atualizarEntregaGeral() {
        this.enviandoRequest = true;
        this.entregaService.updateIntegracaoEntrega(this.entregaGeral).subscribe({
            next: (res) => {
                if (res.success) {
                    this.configSistemaService.alterarEntregaGeral(this.entregaGeral);
                }
            },
            complete: () => this.enviandoRequest = false,
        })
    }

    public recarregarPaginas() {
        this.pesquisarBairro(this.termoPesquisa);
    }

    public pesquisarBairro(termo: string) {
        this.bairrosFiltrados = [...this.bairros.filter((bairro) => bairro.bairro.toLowerCase().includes(termo.toLowerCase()))];

        this.carregarPaginas();
    }

    private calcularTotalPaginas() {
        this.paginador.totalPaginas = Math.ceil(this.bairrosFiltrados.length / this.paginador.qtdItensPagina);
    }

    private carregarPaginas() {
        this.calcularTotalPaginas();
        this.itensPorPagina = this.paginador.paginar(this.bairrosFiltrados);
    }

    public adicionarBairro(bairro: EntregaPorBairroViewModel) {
        if (this.validarBairro(bairro)) {
            const request = new EntregaPorBairroRequest();
            request.ativo = bairro.ativo;
            request.bairro = bairro.bairro;
            request.id = '';
            request.tempoEntrega = bairro.tempoEntrega;
            request.valorEntrega = bairro.valorEntrega;

            this.enviandoRequest = true;
            this.entregaService.postIntegracaoEntrega(request).subscribe({
                next: (res) => {
                    if (res.success) {
                        this.bairros.unshift(bairro);
                        this.limparForm();
                        this.recarregarPaginas();
                    }
                },
                complete: () => this.enviandoRequest = false,
            })
        }
    }

    public validarBairro(bairro: EntregaPorBairroViewModel): boolean {
        return bairro.bairro !== '', bairro.tempoEntrega !== 0, bairro.valorEntrega !== 0;
    }

    public editarBairro(id: string) {
        const bairroEncontrado = JSON.parse(JSON.stringify(this.bairrosFiltrados.find((bairro) => bairro.id === id)));

        if (bairroEncontrado) {
            this.bairroSel = bairroEncontrado;
            this.bairroSel.emEdicao = true;
        }
    }

    public confirmarEdicao() {
        this.bairros.forEach((bairro, index) => {
            if (bairro.id === this.bairroSel.id) {
                const request = new EntregaPorBairroRequest();
                request.ativo = this.bairroSel.ativo;
                request.bairro = this.bairroSel.bairro;
                request.id = this.bairroSel.id;
                request.tempoEntrega = this.bairroSel.tempoEntrega;
                request.valorEntrega = this.bairroSel.valorEntrega;

                this.entregaService.updateIntegracaoEntrega(request).subscribe({
                    next: (res) => {
                        if (res.success) {
                            this.bairros[index] = this.bairroSel;
                            this.recarregarPaginas();
                            this.limparForm();
                        }
                    }
                });
            }
        });
    }

    public cancelarEdicao(id: string) {
        this.bairrosFiltrados.forEach((bairro) => {
            if (bairro.id === id) {
                bairro.emEdicao = false;
            }
        });

        this.limparForm();
    }

    public toggleStatusBairro(bairro: EntregaPorBairroViewModel) {
        this.entregaService.updateIntegracaoEntrega(bairro).subscribe({
            next: (res) => { }
        });
    }

    public deletarBairro(nome: string) {
        this.bairros.forEach((bairro, index) => {
            if (bairro.bairro === nome) {
                this.entregaService.deleteIntegracaoEntrega(nome).subscribe({
                    next: (res) => {
                        if (res.success) {
                            this.bairros.splice(index, 1);
                            this.recarregarPaginas();
                        }
                    }
                });
            }
        });
    }

    public limparForm() {
        this.bairroSel = new EntregaPorBairroViewModel();
    }

    public alterarPagina(pagina: number) {
        if (pagina > this.paginador.totalPaginas || pagina < 1) return;

        this.paginador.paginaAtual = pagina;
        this.recarregarPaginas();
    }
}
